import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { TreeModel } from '@components/tree/tree.model';
import { TreeAdapter } from '@app/shared/util/tree-adapter.utils';
import { Batch } from '@models/batch.model';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-to-batch-modal',
    templateUrl: './add-to-batch-modal.component.html',
    styleUrls: ['./add-to-batch-modal.component.scss']
})
export class AddToBatchModalComponent implements OnChanges {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() tools: any;
    @Input() batches: Batch[];
    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() addToNewBatch = new EventEmitter<any>();
    @Output() addToBatch = new EventEmitter<any>();

    treeDisplayTools: TreeModel[];


    selectedTools: any[];

    batchSelectionForm: UntypedFormGroup;

    newBatchSelected = false;


    constructor(private treeAdapter: TreeAdapter) {
        this.batchSelectionForm = new UntypedFormGroup({
            'id': new UntypedFormControl(''),
            'name': new UntypedFormControl(''),
            'withStorage': new UntypedFormControl(false),
        });
    }

    open() {
        this.modal.open();
    }

    close() {
        this.batchSelectionForm.reset({'withStorage': false});
        this.newBatchSelected = false;
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tools']) {
            this.treeDisplayTools = this.treeAdapter.adaptToolsToTree(this.tools, 'default');
        }
    }

    onCreateNewBatchSelected(selected = false) {
        this.newBatchSelected = selected;
    }

    get areToolsSelected() {
        return this.treeDisplayTools && this.treeDisplayTools.length > 0;
    }

    addToolsToBatch() {
        this.addToBatch.emit({
            tools: this.tools, batchId: parseInt(this.batchSelectionForm.get('id').value, 0),
            withStorage: this.batchSelectionForm.get('withStorage').value
        });
    }

    createNewBatch() {
        this.addToNewBatch.emit({
            tools: this.tools, batchName: this.batchSelectionForm.get('name').value,
            withStorage: this.batchSelectionForm.get('withStorage').value
        });
    }
}
